/* Prayer & Praise
 * ----------------------------------------------------------
 * Forty of the seventy-five letters end with a list of prayer requests under a
 * heading spelled six different ways ("Prayer & Praise", "Praise and Prayer",
 * "Prayer Requests:"...), at levels h1 to h3, as eighteen years of hand-typed
 * newsletters will. In Ghost that renders as one more heading and a list.
 *
 * This finds that heading, normalises it, and wraps the section in an
 * <aside class="hh-prayer"> so higby/prayer.css can set it apart -- across the
 * archive, with no edit to any post. The heading becomes an h2
 * with id="prayer-praise", which is what "Pray with us" on the homepage links
 * to; the heading's original id is kept on an empty anchor so old links still
 * land.
 *
 * What counts as the section: the heading, then everything up to the next
 * heading or rule -- except that once a list has been taken, a paragraph is
 * only taken if it still reads as prayer ("Pray for...", "Praise God..."), so a
 * closing "Partners in the Gospel" signature stays outside.
 */
(function () {
    var content = document.querySelector('.gh-content');
    if (!content) return;
    // New issues carry the box in their own markup (the "Prayer & Praise"
    // snippet), so the email has it too. This script is for the archive only.
    if (content.querySelector('.hh-prayer-card')) return;

    var HEADING = /^\s*(prayers?|praises?)\s*(&|&amp;|and|\/|,)\s*(prayers?|praises?)\s*(requests?|items?)?\s*:?\s*$|^\s*prayer\s*(requests?|points?|items?|needs?)\s*:?\s*$/i;
    var PRAYERISH = /^\s*(•\s*)?(please\s+)?(pray|praise|prayer|thank|give thanks|continue|lift|we (also )?(pray|ask|covet|thank)|and pray|join us|rejoice|for )/i;

    var heads = content.querySelectorAll('h1, h2, h3, h4');
    for (var i = 0; i < heads.length; i++) {
        var h = heads[i];
        if (!HEADING.test(h.textContent)) continue;

        var aside = document.createElement('aside');
        aside.className = 'hh-prayer';
        aside.setAttribute('aria-labelledby', 'prayer-praise');

        if (h.id && h.id !== 'prayer-praise') {
            var anchor = document.createElement('span');
            anchor.id = h.id;
            aside.appendChild(anchor);
        }

        var title = document.createElement('h2');
        title.id = 'prayer-praise';
        title.className = 'hh-prayer-title';
        title.textContent = 'Prayer & Praise';
        aside.appendChild(title);

        h.parentNode.insertBefore(aside, h);
        h.parentNode.removeChild(h);

        var gotList = false;
        var node = aside.nextSibling;
        while (node) {
            var next = node.nextSibling;
            if (node.nodeType !== 1) { aside.appendChild(node); node = next; continue; }
            var tag = node.tagName;
            if (/^H[1-6]$/.test(tag) || tag === 'HR') break;
            if (tag === 'UL' || tag === 'OL') { gotList = true; aside.appendChild(node); node = next; continue; }
            if (tag === 'P' && gotList && !PRAYERISH.test(node.textContent)) break;
            if (tag !== 'P' && tag !== 'UL' && tag !== 'OL' && gotList) break;
            aside.appendChild(node);
            node = next;
        }
        break;
    }
})();
